<template>
  <div class="nd-bread">
    <div class="nd-bread-title">当前位置：</div>
    <el-breadcrumb separator=">">
      <el-breadcrumb-item
        v-for="(item, index) in breadResults"
        :key="index"
        :to="item.to ? item.to :''"
        :replace="item.replace ? true : false"
      >{{ item.title }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'Bread',
  props: ['breadResults']
}
</script>

<style lang="scss">
</style>
